module.exports = { src: __webpack_public_path__ + "media/priceMyRentalHero.ca68ecd7.webp", width: 1437, height: 504 };